<template>
  <div class="ws-chapter-main">
    <ValidationObserver ref="form">
      <WsBreadCrumbs :items="_breadcrumbsItems"> </WsBreadCrumbs>
      <WsTitle v-if="_editType==='updateCurrentVersion'">編輯當前版本題目</WsTitle>
      <WsTitle v-else-if="_editType==='createVersion'">更新題目版本</WsTitle>
      <div
        v-if="isLoading"
        class="loading-section"
      >
        <v-skeleton-loader
          v-for="n in 3"
          :key="`skeleton-${n}`"
          type="list-item-three-line"
          :tile="true"
          class="mt-5"
        ></v-skeleton-loader>
      </div>
      <div
        class="chapter-box"
        v-for="(chapterItem,chapterIndex) in state.chapters"
        :key="`${chapterIndex}${chapterItem}`"
      >

        <InputBlock
          :title="'章'"
          :value="state.chapters[chapterIndex].chapterTitle"
          @input="$_onChapterTitle($event,chapterIndex)"
        >
          <template v-slot:rightBtn>
            <InputBlockBtn
              :arrayLength="state.chapters.length"
              @deleteList="$_onDelete(['chapters',chapterIndex])"
            />
          </template>
        </InputBlock>

        <div
          class="section-box"
          v-for="(sectionItem,sectionIndex) in state.chapters[chapterIndex].sections"
          :key="`${sectionIndex}${sectionItem}`"
        >
          <InputBlock
            :title="'節'"
            :value="state.chapters[chapterIndex].sections[sectionIndex].sectionTitle"
            @input="$_onSectionTitle($event,chapterIndex,sectionIndex)"
          >
            <template v-slot:rightBtn>
              <InputBlockBtn
                :arrayLength="chapterItem.sections.length"
                @deleteList="$_onDelete(['sections',chapterIndex,sectionIndex])"
              />
            </template>
          </InputBlock>
          <div
            class="topic-box"
            v-for="(topicItem,topicIndex) in state.chapters[chapterIndex].sections[sectionIndex].topics"
            :key="`${topicIndex}${topicItem}`"
          >
            <InputBlock
              :title="'題目'"
              showTitle
              :placeholder="'請輸入題目'"
              :arrayLength="sectionItem.topics.length"
              :fields="fields"
              :modelName="modelName"
              :updateData="$_updateData(chapterIndex,sectionIndex,topicIndex)"
              :versionModelName="_versionModelName"
              :customParentData="_customParentData"
              @activeToggle="$_openActiveToggle($event,topicIndex,chapterIndex,sectionIndex)"
              @deleteList="$_onDelete(['topics',chapterIndex,sectionIndex,topicIndex])"
              :itemVersionCreatable="_itemVersionCreatable"
              isTopicList
              @createVersionClick="$_isCreateVersion(chapterIndex,sectionIndex,topicIndex)"
              v-model="sectionItem.topics[topicIndex]"
            >
              <template v-slot:detail>
              </template>
            </InputBlock>
          </div>
          <div class="topic-box">
            <WsBtn
              class="ws-slick-sort__topic-btn"
              @click="$_addTopic(chapterIndex,sectionIndex)"
              color="primary"
              outlined
            >
              <v-icon left>mdi-plus</v-icon> 新增題目
            </WsBtn>
          </div>

          <WsBtn
            class="ws-slick-sort__section-btn"
            @click="$_addSection(chapterIndex,sectionIndex)"
            color="primary"
            outlined
          >
            <v-icon left>mdi-plus</v-icon> 新增節
          </WsBtn>
        </div>
        <WsBtn
          class="ws-slick-sort__chapter-btn"
          @click="$_addChapter(chapterIndex)"
          color="primary"
          outlined
        >
          <v-icon left>mdi-plus</v-icon> 新增章
        </WsBtn>
      </div>
      <WsMainBottomNav>
        <WsBtn
          color="textSecondary"
          outlined
          @click="$router.go(-1)"
        >取消</WsBtn>
        <WsBtn @click="$_onSubmit()">送出</WsBtn>
      </WsMainBottomNav>
      <WsAlertDialog
        ref="deleteDialog"
        title="確定要刪除嗎？"
        :description="_deleteAlertName"
        @submit="$_deleteList($event)"
      />
    </ValidationObserver>

  </div>
</template>
<script>
export default {
  name: "WsChapterMain",
  data: () => ({
    newObject: {},
    parentModelData: {},
    modelData: {},
    modelVersionData: {},
    updateData: [],
    state: {
      chapters: [],
    },
    deleteName: "",
    createErrorMessages: null,
    borderColor: "",
    submitLoading: false,
    parentLabel: "",
    isLoading: false,
  }),
  props: {
    label: {
      type: String,
      default: "",
    },
    modelName: {
      type: String,
      default: "",
    },
    modelVersionName: {
      type: String,
      default: "",
    },
    fields: {
      type: Object,
      default() {
        return {};
      },
    },
    parentModelName: {
      type: String,
      default: "",
    },
    parentVersionModelName: {
      type: String,
      default: "",
    },
    parentTitleKey: {
      type: String,
      default: "",
    },
    editType: {
      type: String,
      default: null,
    },
    customParentData: {
      type: Function,
      default() {
        return;
      },
    },
    fieldsRead: {
      type: Array,
      default: null,
    },
    titleKey: {
      type: String,
      default: "",
    },
    hasChapters: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    async fetchData() {
      this.$store.dispatch("locale/changeLanguageDisable");
      this.isLoading = true;
      //give modelName
      await this.$_parentModelData();
      //get last parentModel version data
      if (!this.parentModelData.last_version.chapters) {
        await this.$_stateInit();
      } else {
        //get model data
        let params = {};
        params[`${this.parentVersionModelName}s`] =
          this.parentModelData.last_version.id;
        await this.$_getModelData(`/${this.modelName}`, params);
        //設定 state
        let newArray;
        newArray = JSON.parse(
          JSON.stringify(this.parentModelData.last_version)
        );

        newArray.chapters.forEach((chapterItem) => {
          chapterItem.sections.forEach((sectionItem) => {
            sectionItem.topics.forEach((topicItem, topicIndex) => {
              this.modelData.forEach((questionItem) => {
                if (topicItem.id === questionItem.id) {
                  sectionItem.topics[topicIndex] = {
                    ...sectionItem.topics[topicIndex],
                    ...questionItem,
                  };
                  sectionItem.topics[topicIndex].openActive = false;
                }
              });
            });
          });
        });
        this.state = JSON.parse(JSON.stringify(newArray));
        // delete this.state.chapters[0].sections[0].topics[0].last_version.acts;
        // delete this.state.chapters[0].sections[0].topics[0].last_version
        //   .articles;
        // delete this.state.chapters[0].sections[0].topics[0].last_version
        //   .effects;
      }
      this.isLoading = false;
    },
    $_stateInit() {
      let date = new Date();
      let randomId = `${date.getFullYear()}${date.getMonth()}${date.getDate()}${date.getMinutes()}${Math.random()
        .toString(36)
        .substring(10)}`;
      this.state.chapters.push({
        chapterTitle: "",
        badId: `c${randomId}`,
        sections: [],
      });
      this.state.chapters[0].sections.push({
        sectionTitle: "",
        badId: `s${randomId}`,
        topics: [],
      });
      this.$_addTopic(0, 0);
    },
    $_addTopic(chapterIndex, sectionIndex) {
      let topicObj =
        this.state.chapters[chapterIndex].sections[sectionIndex].topics;
      topicObj.push({
        openActive: false,
        status: 1,
        isNewTopic: true,
      });
      this.$_CMS_updateDataSetFromFields(
        this,
        topicObj[topicObj.length - 1],
        this.fields
      );
      topicObj[topicObj.length - 1].last_version = {};
      topicObj[topicObj.length - 1].last_version.title = "";
    },
    $_addSection(chapterIndex, sectionIndex) {
      let date = new Date();
      let randomId = `${date.getFullYear()}${date.getMonth()}${date.getDate()}${date.getMinutes()}${Math.random()
        .toString(36)
        .substring(10)}`;
      let newSections = JSON.parse(
        JSON.stringify(this.state.chapters[chapterIndex].sections)
      );
      newSections.splice(sectionIndex + 1, 0, {
        sectionTitle: "",
        badId: `s${randomId}`,
        topics: [],
      });
      this.state.chapters[chapterIndex].sections = newSections;
      this.$_addTopic(chapterIndex, sectionIndex + 1);
    },
    $_addChapter(chapterIndex) {
      let date = new Date();
      let randomId = `${date.getFullYear()}${date.getMonth()}${date.getDate()}${date.getMinutes()}${Math.random()
        .toString(36)
        .substring(10)}`;
      let newState = JSON.parse(JSON.stringify(this.state));
      newState.chapters.splice(chapterIndex + 1, 0, {
        chapterTitle: "",
        badId: `c${randomId}`,
        sections: [],
      });
      this.state = newState;

      this.state.chapters[chapterIndex + 1].sections.push({
        sectionTitle: "",
        badId: `s${randomId}`,
        topics: [],
      });
      this.$_addTopic(chapterIndex + 1, 0);
    },
    $_openActiveToggle(val, topicIndex, chapterIndex, sectionIndex) {
      this.state.chapters[chapterIndex].sections[sectionIndex].topics[
        topicIndex
      ].openActive = val;
      this.state.chapters[chapterIndex].sections[sectionIndex].topics[
        topicIndex
      ].isEditTopic = true;
    },
    $_deleteList($event) {
      if ($event[0] === "chapters") {
        this.state.chapters.splice($event[1], 1);
      } else if ($event[0] === "sections") {
        this.state.chapters[$event[1]].sections.splice($event[2], 1);
      } else if ($event[0] === "topics") {
        this.state.chapters[$event[1]].sections[$event[2]].topics.splice(
          $event[3],
          1
        );
      }
      this.$refs.deleteDialog.close();
    },
    $_onDelete($event) {
      this.$refs.deleteDialog.open($event);
      this.deleteName = $event[0];
    },
    async $_onSubmit() {
      const isValidate = await this.$refs.form.validate();
      if (!isValidate) {
        return;
      }
      this.submitLoading = true;

      try {
        //post question_template
        let postUrl;
        let modelTasks = [];
        postUrl = `/${this.modelName}`;
        this.state.chapters.forEach((chapterItem) => {
          chapterItem.sections.forEach((sectionItem) => {
            sectionItem.topics.forEach((topicItem) => {
              if (!topicItem.id) {
                let newObject = {};
                newObject[`${this.parentModelName}s`] = this.$route.params.id;
                newObject[`${this.parentVersionModelName}s`] =
                  this.parentModelData.last_version.id;
                modelTasks.push(this.$axios.post(postUrl, newObject));
              }
            });
          });
        });
        const modelRes = await Promise.all(modelTasks);
        //update topic.id of this.state
        let modelResIndex = 0;
        this.state.chapters.forEach((chapterItem) => {
          chapterItem.sections.forEach((sectionItem) => {
            sectionItem.topics.forEach((topicItem) => {
              if (!topicItem.id) {
                topicItem.id = modelRes[modelResIndex].data.data.id;
                modelResIndex++;
              }
            });
          });
        });
        try {
          //post template_version
          let params = {};
          params[`${this.parentVersionModelName}s`] =
            this.parentModelData.last_version.id;
          await this.$_getModelData(`/${this.modelName}`, params);
          let newObject = {};
          newObject.chapters = [];
          this.state.chapters.forEach((chapterItem, chapterIndex) => {
            newObject.chapters.push({
              badId: chapterItem.badId,
              chapterTitle: chapterItem.chapterTitle,
              sections: [],
            });
            if (this.parentModelData.sequence) {
              newObject.sequence = this.parentModelData.sequence;
            }
            if (this.parentModelData.last_version.locales) {
              newObject.locales = this.parentModelData.last_version.locales;
            }
            chapterItem.sections.forEach((sectionItem, sectionIndex) => {
              let sectionObject = {};
              sectionObject["badId"] = sectionItem.badId;
              sectionObject["sectionTitle"] = sectionItem.sectionTitle;
              sectionObject["topics"] = [];
              newObject.chapters[chapterIndex].sections.push(sectionObject);
              sectionItem.topics.forEach((topicItem) => {
                this.modelData.forEach((modelItem) => {
                  if (modelItem.id === topicItem.id) {
                    newObject.chapters[chapterIndex].sections[
                      sectionIndex
                    ].topics.push({
                      id: modelItem.id,
                    });
                  }
                });
              });
            });
          });
          newObject[`${this.modelName}s`] = this.modelData.map((modelItem) => {
            return modelItem.id;
          });
          //if have add chapter ever
          let parentModelVersionRes = {};
          parentModelVersionRes = await this.$axios.patch(
            `/${this.parentVersionModelName}/${this.parentModelData.last_version.id}`,
            newObject
          );
          try {
            //post question_template's version
            let questionVersionTasks = [];
            this.state.chapters.forEach((chapterItem) => {
              chapterItem.sections.forEach((sectionItem) => {
                sectionItem.topics.forEach((topicItem) => {
                  this.modelData.forEach((modelItem) => {
                    if (modelItem.id === topicItem.id) {
                      let newObject = JSON.parse(
                        JSON.stringify(topicItem.last_version)
                      );
                      newObject.payload = {
                        chapterId: chapterItem.badId,
                        sectionId: sectionItem.badId,
                      };
                      newObject[this.modelName] = modelItem.id;
                      if (topicItem.status) {
                        newObject.status = 1;
                      }
                      newObject[`${this.parentVersionModelName}s`] =
                        parentModelVersionRes.data.data.id;
                      if (
                        (this._editType === "createVersion" &&
                          topicItem.isCreateVersion) ||
                        !modelItem.last_version
                      ) {
                        questionVersionTasks.push(
                          this.$axios.post(
                            `/${this._versionModelName}`,
                            newObject
                          )
                        );
                      } else {
                        if (
                          this._editType === "createVersion" ||
                          !topicItem.isEditTopic
                        ) {
                          return;
                        }
                        questionVersionTasks.push(
                          this.$axios.patch(
                            `/${this._versionModelName}/${modelItem.last_version.id}`,
                            newObject
                          )
                        );
                      }
                    }
                  });
                });
              });
            });
            await Promise.all(questionVersionTasks);
            //post done
            this.submitLoading = false;
            this.$store.dispatch("app/stopNeedSave");
            this.$router.push(
              `/${this.parentModelName}/${this.$route.params.id}`
            );
          } catch (error) {
            alert(error, "題目版本儲存發生錯誤");
            this.submitLoadging = false;
          }
        } catch (error) {
          alert(error, "公版版本儲存發生錯誤");
          this.submitLoading = false;
        }
      } catch (error) {
        alert(error, "題目儲存發生錯誤");
        this.submitLoading = false;
      }
    },
    async $_parentModelData() {
      this.$store.dispatch("app/startPageLoading");
      let getUrl = `/${this.parentModelName}/${this.$route.params.id}`;
      if (this.localeMode) {
        getUrl += `?locale=${this._selectingLocale}`;
      }
      try {
        const res = await this.$axios.get(getUrl);
        this.parentModelData = res.data.data;
      } catch (error) {
        alert(error);
      } finally {
        this.$store.dispatch("app/stopPageLoading");
      }
    },
    async $_getModelVersionData(getUrl, params) {
      //audit_question_template (index)
      try {
        const res = await this.$axios.get(getUrl, {
          params: params,
        });
        this.modelVersionData = res.data.data;
      } catch (error) {
        alert(error);
      }
    },
    async $_getModelData(getUrl, params) {
      try {
        const res = await this.$axios.get(getUrl, { params: params });
        this.modelData = res.data.data;
      } catch (error) {
        alert(error);
      }
    },
    $_updateData(chapterIndex, sectionIndex, topicIndex) {
      let data = null;
      this.updateData.forEach((item) => {
        if (
          this.state.chapters[chapterIndex].sections[sectionIndex].topics[
            topicIndex
          ].id === item.id
        ) {
          data = item;
        }
      });
      return data;
    },
    $_onUpdateSubmit($event, chapterIndex, sectionIndex, topicIndex) {
      if ($event.last_version) {
        $event.needUpdate = true;
        $event.last_version.title =
          $event.last_version.locales[this._selectingLocale].title;
      }
      this.state.chapters[chapterIndex].sections[sectionIndex].topics[
        topicIndex
      ] = {
        ...this.state.chapters[chapterIndex].sections[sectionIndex].topics[
          topicIndex
        ],
        ...$event,
      };
    },
    $_itemDeletable(topicsData) {
      if (!topicsData) return false;
      if (topicsData.length > 1) {
        return true;
      }
      return false;
    },
    $_onInput($event, chapterIndex, sectionIndex, topicIndex) {
      this.state.chapters[chapterIndex].sections[sectionIndex].topics[
        topicIndex
      ] = $event;
    },
    $_isCreateVersion(chapterIndex, sectionIndex, topicIndex) {
      if (
        !this.state.chapters[chapterIndex].sections[sectionIndex].topics[
          topicIndex
        ].isCreateVersion
      ) {
        this.$set(
          this.state.chapters[chapterIndex].sections[sectionIndex].topics[
            topicIndex
          ],
          "isCreateVersion",
          true
        );
      } else {
        this.$set(
          this.state.chapters[chapterIndex].sections[sectionIndex].topics[
            topicIndex
          ],
          "isCreateVersion",
          !this.state.chapters[chapterIndex].sections[sectionIndex].topics[
            topicIndex
          ].isCreateVersion
        );
      }
    },
    $_onTopicInput($event, chapterIndex, sectionIndex, topicIndex) {
      this.state.chapters[chapterIndex].sections[sectionIndex].topics[
        topicIndex
      ] = {
        ...this.state.chapters[chapterIndex].sections[sectionIndex].topics[
          topicIndex
        ],
        ...$event,
      };
    },
    $_onChapterTitle($event, chapterIndex) {
      this.state.chapters[chapterIndex].chapterTitle = $event;
    },
    $_onSectionTitle($event, chapterIndex, sectionIndex) {
      this.state.chapters[chapterIndex].sections[sectionIndex].sectionTitle =
        $event;
    },
  },
  computed: {
    _parentTitle() {
      if (!this.parentModelName) {
        return null;
      } else if (!this.parentModelData) {
        return this.parentLabel;
      } else {
        return this.$_CMS_getValueByFieldKey(
          this.parentTitleKey,
          this.parentModelData
        );
      }
    },
    _breadcrumbsItems() {
      if (!this.parentModelData) {
        return [];
      }
      if (!this.parentModelData.last_version) {
        return [];
      }
      const _breadcrumbsItems = [];
      _breadcrumbsItems.push({
        text: this.label,
        to: `/${this.parentModelName}`,
        disabled: false,
      });
      _breadcrumbsItems.push({
        text: this.parentModelData.name,
        to: `/${this.parentModelName}/${this.$route.params.id}`,
        disabled: false,
      });
      if (this._editType === "updateCurrentVersion") {
        _breadcrumbsItems.push({
          text: "編輯當前版本題目",
          disabled: true,
        });
      } else if (this._editType === "createVersion") {
        _breadcrumbsItems.push({
          text: "更新題目版本",
          disabled: true,
        });
      }
      return _breadcrumbsItems;
    },
    _versionModelName() {
      return `${this.modelName}_version`;
    },
    _updateFields() {
      return this.$_CMS_geUpdateFields(this.fields);
    },
    _deleteAlertName() {
      return this.deleteName === "chapters"
        ? "請再三確認，章以下的節與題目也會一併刪除。"
        : this.deleteName === "sections"
        ? "請再三確認，節以下的題目也會一併刪除。"
        : "請再三確認，刪除後的題目將一去不復返。";
    },
    _customParentData() {
      if (this.customParentData) {
        return this.customParentData(this.parentModelData);
      } else {
        return null;
      }
    },
    _itemVersionLinkCreatable() {
      return false;
    },
    _itemVersionCreatable() {
      if (this.parentModelData) {
        if (this.parentModelData.last_version.version_status == 0) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    _itemVersionReadable() {
      return false;
    },
    _itemEditable() {
      if (this.modelData) {
        if (!this.parentModelData.last_version.version_status) {
          return false;
        } else {
          return true;
        }
      }
      return false;
    },
    _itemDeletable() {
      return true;
    },
    _itemLinkCheckable() {
      return false;
    },
    _selectingLocale() {
      return this.$store.state.locale.selectingLocale;
    },
    _state() {
      return this.state;
    },
    _editType() {
      if (this.editType) {
        return this.editType;
      } else if (this.parentModelData.last_version) {
        if (this.parentModelData.last_version.version_status) {
          return "updateCurrentVersion";
        } else {
          return "createVersion";
        }
      } else {
        return "updateCurrentVersion";
      }
    },
  },
  created() {
    this.fetchData();
  },
};
</script>

<style lang="scss">
@import "@/__vue2cmsstonevuetify/assets/scss/ws-chapter-main.scss";
</style>